import styled from 'styled-components';

export const AssetInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme: { token } }) => token.padding}px;

  .label-value-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: ${({ theme: { token } }) => token.marginLG}px;
  }

  .real-time-data-container {
    margin-top: ${({ theme: { token } }) => token.margin}px;
  }

  .collapse-container {
    padding: ${({ theme: { token } }) => token.padding}px;
  }

  .service-information-container {
    align-items: flex-end;
  }

  .service-information-title {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .card-container {
    margin: ${({ theme: { token } }) => token.marginLG}px 0 ${({ theme: { token } }) => token.margin}px;

    .centrifugal-sliders {
      display: flex;
      flex-direction: row;
      gap: ${({ theme: { token } }) => token.marginXXL}px;

      .centrifugal-slider-wrapper {
        width: 50%;
      }
    }

    .main-slider {
      margin: 0 auto;

      .details-widget-slider {
        .slider-container {
          .value {
            margin-bottom: 0;

            .value-content {
              font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
            }

            .units-sign {
              bottom: 4px;
            }
          }

          .slider {
            &:before {
              margin-left: -16.2601626%;
              width: 16.2601626%;
            }

            &:after {
              margin-right: -16.2601626%;
              width: 16.2601626%;
            }
          }

          .triangle {
            height: 8px;
            width: 12px;
            margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
          }
        }
      }
    }
  }

  .service-information-collapse {
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }

  .sliders-horizontal-icon {
    line-height: ${({ theme: { token } }) => token.lineHeight}px;
  }

  .alert-tab-label {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    font-size: ${({ theme: { token } }) => token.fontSize}px;
  }

  .archived {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
  }
`;
